/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_Type_TeamInputs */

const en_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const fr_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe`)
};

const de_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const it_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadra`)
};

const ru_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команда`)
};

const es_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo`)
};

const zh_cn2_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队`)
};

const ja_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム`)
};

const hi_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम`)
};

const pt_pt2_options_general_project_type_team = /** @type {(inputs: Options_General_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipe`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Options_General_Project_Type_TeamInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_type_team = /** @type {((inputs?: Options_General_Project_Type_TeamInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_Type_TeamInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_project_type_team(inputs)
	if (locale === "de") return de_options_general_project_type_team(inputs)
	if (locale === "it") return it_options_general_project_type_team(inputs)
	if (locale === "ru") return ru_options_general_project_type_team(inputs)
	if (locale === "es") return es_options_general_project_type_team(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_project_type_team(inputs)
	if (locale === "ja") return ja_options_general_project_type_team(inputs)
	if (locale === "hi") return hi_options_general_project_type_team(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_project_type_team(inputs)
	return en_options_general_project_type_team(inputs)
});